// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"486":"2c90259a","938":"484ac0f0","971":"166e2851"}[chunkId] + ".chunk.css");